import { GettextInterface } from "@indeed/indeed-gettext"

export const titleNormStatuses = [
    "NORMALIZED",
    "UNNORMALIZED",
    "BLACKLISTED",
    "GENERIC",
    "CATEGORY",
    "INTERNAL_ERROR",
    "WRONG_INDEX_VERSION",
    "ARTIFACT_FAILURE",
    null,
]

export type TitleNormStatus = (typeof titleNormStatuses)[number]

export const defaultConceptAttribute = {
    suid: "" as string,
    displayLabel: "" as string,
    customClassSuids: [] as string[],
    isVerified: false as boolean | undefined,
}

export const defaultJobRequirement = {
    suid: "" as string,
    label: "" as string,
}

export function getSalaryTypeMap(gettext: GettextInterface["gettext"]) {
    return {
        NONE: "",
        HOURLY: gettext("per hour"),
        DAILY: gettext("per day"),
        WEEKLY: gettext("per week"),
        MONTHLY: gettext("per month"),
        YEARLY: gettext("per year"),
        BIWEEKLY: gettext("biweekly"),
        QUARTERLY: gettext("per quarter"),
    }
}

export type ISalaryType = keyof ReturnType<typeof getSalaryTypeMap>

export const defaultSalaryInfo = {
    currency: "" as string | undefined | null,
    currencySymbol: "" as string | undefined | null,
    payRate: 0.0 as number | undefined | null,
    salaryType: "" as ISalaryType | undefined | null,
    annualSalary: 0.0 as number | undefined | null,
}

export const defaultNormTitleInfo = {
    normTitle: "" as string | undefined,
    titleNormStatus: null as TitleNormStatus,
}
export interface IBaseJobInfo {
    normTitleInfo: INormTitleInfo | undefined
    salaryInfo: ISalaryInfo | undefined
    companyName: string | undefined
    jobKey: string
    city: string | undefined
    state: string | undefined
    postalCode: string | undefined
    isRemote: boolean | undefined
}

export const defaultBaseJobInfo: IBaseJobInfo = {
    normTitleInfo: defaultNormTitleInfo,
    salaryInfo: defaultSalaryInfo,
    companyName: "",
    jobKey: "",
    city: "",
    state: "",
    postalCode: "",
    isRemote: false,
}

export const defaultFeedbackJobInfo = {
    companySectors: [] as IConceptAttribute[] | undefined,
    schedules: [] as IConceptAttribute[] | undefined,
    mostSpecificOccupations: [] as IConceptAttribute[] | undefined,
    jobTypes: [] as IConceptAttribute[] | undefined,
    certificationRequirements: [] as IJobRequirement[] | undefined,
    educationRequirements: [] as IJobRequirement[] | undefined,
    languageRequirements: [] as IJobRequirement[] | undefined,
    licenseRequirements: [] as IJobRequirement[] | undefined,
    skillRequirements: [] as IJobRequirement[] | undefined,
}

export type IFeedbackJobInfo = IBaseJobInfo & typeof defaultFeedbackJobInfo
export type IJobInfo = IFeedbackJobInfo
export type INormTitleInfo = typeof defaultNormTitleInfo
export type ISalaryInfo = typeof defaultSalaryInfo
export type IConceptAttribute = typeof defaultConceptAttribute
export type IJobRequirement = typeof defaultJobRequirement
